<template>
    <div class="e6-select">
        <el-popover
                popper-class="e6-select-tree"
                v-model="visible"
                placement="bottom-start"
                @hide="handleHide"
                @show="handleShow"
                width="400"
                trigger="click"
                :disabled="disabled"
        >
            <el-scrollbar wrap-class="e6-tree-wrapper">
                <el-tree
                        show-checkbox
                        default-expand-all
                        node-key="id"
                        ref="selectTree"
                        :data="data"
                        :filter-node-method="filterNode"
                        :check-strictly="checkStrictly"
                        :expand-on-click-node="false"
                        @check-change="handleCheckChange"
                ></el-tree>
            </el-scrollbar>
            <el-input
                    :value="selectValue"
                    @clear="handleclear"
                    @input="handleFilter"
                    slot="reference"
                    :placeholder="placeholder"
                    :disabled="disabledInput"
                    clearable
            ></el-input>
        </el-popover>
    </div>
</template>

<script>
    export default {
        name: "E6SelectPri",
        props: {
            data: {
                type: Array,
                default: function () {
                    return [];
                }
            },
            placeholder: {
                type: String,
                default: "请输入内容"
            },
            multiple: {
                type: Boolean,
                default: true
            },
            filter: {
                type: Boolean,
                default: true
            },
            disabled: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                visible: false,
                selectValue: "",
                editCheckId: "",
                timer: null
            };
        },
        computed: {
            checkStrictly() {
                return !this.multiple;
            },
            disabledInput() {
                return !this.filter;
            }
        },
        methods: {
            handleFilter(val) {
                this.$refs.selectTree.filter(val);
            },
            filterNode(value, data) {
                if (!value) return true;
                return data.label.indexOf(value) !== -1;
            },
            getCheckedNodes() {
                return this.$refs.selectTree.getCheckedNodes();
            },
            getCheckedKeys() {
                return this.$refs.selectTree.getCheckedKeys();
            },
            setCheckedNodes(data) {
                this.$refs.selectTree.setCheckedNodes(data);
            },
            setCheckedKeys(data) {
                this.$refs.selectTree.setCheckedKeys(data);
                clearTimeout(this.timer);
                this.timer = setTimeout(() => {
                    this.setSelectValue(this.getCheckedNodes());
                }, 0);
            },
            resetChecked() {
                this.selectValue = "";
                this.$refs.selectTree.setCheckedKeys([]);
            },
            handleCheckChange(item, node) {
                if (!this.multiple) {
                    if (node === true) {
                        //点击未选中复选框
                        this.editCheckId = item.id;
                        this.$refs.selectTree.setCheckedKeys([item.id]);
                    } else {
                        if (this.editCheckId === item.id) {
                            this.$refs.selectTree.setCheckedKeys([]);
                        }
                    }
                }
            },
            setSelectValue(data) {
                if (this.multiple) {
                    this.selectValue =
                        data.length > 0 ? (this.selectValue = "已选择：" + data.length) : "";
                } else {
                    this.selectValue =
                        data.length === 1 ? (this.selectValue = data[0].label) : "";
                }
            },
            setValue(value) {
                this.selectValue = value;
            },
            handleClickNative() {
                this.visible = true;
            },
            handleclear() {
                this.selectValue = "";
                this.resetChecked();
            },
            // 弹框隐藏时回调
            handleHide() {
                let selected = this.$refs.selectTree.getCheckedNodes();
                this.setSelectValue(selected);
                this.$emit("hide");
            },
            // 弹框展示时回调
            handleShow() {
                this.$emit("show");
            }
        },
        beforeDestroy() {
            this.timer = null;
        }
    };
</script>
